import { useCaseAppSettingItemValue } from '@repo/ccc-case-app-lib/src/lib/caseAppSettings.ts'
import { useApplyPageTheme } from '@repo/internal-tools-app-lib/src/lib/useApplyPageTheme.ts'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router.tsx'

/**
 * This App component is outside the router.
 * Route changes don't re-render this component.
 */
export const App = () => {
  const theme = useCaseAppSettingItemValue('appearance.colorTheme', {
    shouldTrackStateInAnalytics: true,
  })
  useApplyPageTheme(theme)

  return <RouterProvider router={router} />
}
